import { SharedPaymentMethodsState } from 'src/app/_shared/stores/settlements/shared-payment-methods/shared-payment-methods.state';
import { BenefDto, FournisseurDto } from 'src/graphql/generated-types';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';

export abstract class SharedBasePaymentMethods {

    abstract accountingEntryLabel: string;

    /**
     * This property is required because we cannot use the `thirdParty` getter as it will
     * always be null when the class is instanciated.
     */
    abstract thirdPartyId: number;

    protected isInitialized = new BehaviorSubject(false);

    constructor(protected store: Store, public activityId: number) {
    }

    get isInitialized$(): Observable<boolean> {
        return this.isInitialized.asObservable();
    }

    /**
     * This getter is going to be available when `initPaymentMethods` is done.
     */
    get third(): BenefDto | FournisseurDto {
        return this.store.selectSnapshot(SharedPaymentMethodsState.third);
    }

    abstract initPaymentMethods(): Observable<any>;

}
